/*
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { useOktaAuth } from "@okta/okta-react";
import React, { useState, useEffect } from "react";
import SignIn from "../pages/SignIn";
import Home from "../pages/Home";
import Loader from "../utils/Loader";
import { getUserApplicationList } from "../API/AuthApiService";
import { useDispatch, useSelector } from "react-redux";
import { setUser, setUserApplications } from "../slices/userSlice";
// import axios from "axios";
import { getAPI } from "../API/ApiService";
import { OktaAuth } from "@okta/okta-auth-js";
const Authenticated = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const [isPageLoading, setPageLoading] = useState(false);
  const { user } = useSelector((store) => store.user);

  const dispatch = useDispatch();
  const authToken = localStorage.getItem("token");

  const fetchApplication = async () => {
    try {
      const data = await oktaAuth.getUser();
      dispatch(setUser(data));
      const newData = await fetchUserId(data?.email);
      return newData;
    } catch (error) {
      console.log("fetchUserId Getting Error from the ", error);
      setPageLoading(false);
    }
  };
  useEffect(() => {
    if (!authState || !authState.isAuthenticated) {
      // When user isn't authenticated, forget any user info
      dispatch(setUser(null));
    } else {
      setPageLoading(true);
      localStorage.setItem("token", authState?.accessToken?.accessToken);
      fetchApplication()
        ?.then((info) => {
          if (info?.status === 200) {
            console.log(info, "----infoDatatatata----------");

            dispatch(setUserApplications(info?.data?.applications));
            setPageLoading(false);
          } else if (info?.status > 400) {
            dispatch(setUserApplications());
            setPageLoading(false);
          }
        })
        .catch((error) => {
          console.log("fetchApplication Getting Error from the ", error);
          setPageLoading(false);
        });
    }
  }, [authState, oktaAuth]); // Update if authState changes

  const fetchUserId = async (email) => {
    const response = await getAPI(
      `${process.env.REACT_APP_AUTH_SERVICE_API_BASE_URL}/auth/users/email/${email}
   `
    );
    console.log("");
    if (response?.status === 200) {
      return response;
    }
    if (response?.status > 400) {
      return response;
    }
  };

  if (!authState) {
    return <Loader />;
  }

  return (
    <div>
      <div>
        {isPageLoading ? (
          <Loader />
        ) : (
          authState.isAuthenticated && user && <Home />
        )}

        {!authState.isAuthenticated && <SignIn />}
      </div>
    </div>
  );
};
export default Authenticated;
